import { addHours, endOfDay, format, formatISO, isValid, lastDayOfMonth, parse, parseISO } from "date-fns"
import ja from "date-fns/locale/ja"

export const dateFormat = (date: number | Date, formatString: string) => format(date, formatString, { locale: ja })

export const formatYearMonthDay = (date: number | Date) => dateFormat(date, "yyyy/MM/dd")
export const formatYearMonthDayHourMinute = (date: number | Date) => dateFormat(date, "yyyy/MM/dd HH:mm")
export const formatYearMonthDayHourMinuteSecond = (date: number | Date) => dateFormat(date, "yyyy/MM/dd HH:mm:ss")
export const formatYearMonthDayOfWeek = (date: number | Date) => `${formatYearMonthDay(date)} (${getDayOfWeek(date)})`
export const formatJapaneseYearMonthDay = (date: number | Date) => dateFormat(date, "yyyy年MM月dd日")
export const formatMonthDay = (date: number | Date) => dateFormat(date, "M/d")
export const formatHourMinute = (date: number | Date) => dateFormat(date, "HH:mm")
export const formatISODate = (date: number | Date) => formatISO(date, { representation: "date" })
/**
 * @returns 曜日が漢字一文字で出力されます。
 */
export const getDayOfWeek = (date: number | Date) => dateFormat(date, "EEEEEE")

export const formatJSTYearMonthDay = (utcDate: number | Date) => {
  const jstDate = addHours(utcDate, 9)
  const year = jstDate.getUTCFullYear()
  const month = (jstDate.getUTCMonth() + 1).toString().padStart(2, "0")
  const day = jstDate.getUTCDate().toString().padStart(2, "0")
  return `${year}/${month}/${day}`
}

const assertValidDate = (date: Date, dateString: string) => {
  if (!isValid(date)) {
    throw new RangeError(`invalid date ${dateString}`)
  }
}

/**
 * @throws {RangeError}
 */
export const parseYearMonthDay = (dateString: string) => {
  const date = parse(dateString, "yyyy/MM/dd", 0)
  assertValidDate(date, dateString)
  return date
}

/**
 * @throws {RangeError}
 */
export const parseYearMonthDayHourMinute = (dateString: string) => {
  const date = parse(dateString, "yyyy/MM/dd HH:mm", 0)
  assertValidDate(date, dateString)
  return date
}

/**
 * @param dateString yyyy年MM月dd日形式の文字列
 * @throws {RangeError}
 */
export const parseJapaneseDate = (dateString: string) => {
  const date = parse(dateString, "yyyy年MM月dd日", 0)
  assertValidDate(date, dateString)
  return date
}

/**
 * @param cardExpire MM/yy形式の文字列
 * @returns 有効期限の月の最終日の23:59:59.999
 * @throws {RangeError}
 */
export const parseCreditCardExpire = (cardExpire: string) => {
  // date-fnsのparseの仕様で年を下2桁のみで渡した場合、
  // referenceDateに基づいて上2桁を決定するため、
  // 明示的に20xx年になるように有効期限を変換します。
  const cardExpireWith20xx = cardExpire.replace("/", "/20")
  const date = endOfDay(lastDayOfMonth(parse(cardExpireWith20xx, "MM/yyyy", 0)))
  assertValidDate(date, cardExpire)
  return date
}

export const parseISO8601 = (date: string) => parseISO(date)

/**
 * @deprecated APIの戻り値はAPI側でstring→Dateへ変換し、formatYearMonthDayを直接使うようにしてください。
 */
export const toSlashDateFromISOString = (ISOString: string) => {
  return formatYearMonthDay(parseISO8601(ISOString))
}
